import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  assetsResizablePanelWrapper: {
    borderRadius: 0,
    height: '100%'
  },
  assetsSearchWrapper: {
    padding: '0rem 1.5rem 1rem 1.5rem'
  }
}));

export default useStyles;
